import React from "react";
import styled, { keyframes } from "styled-components";
import colors from "../../../constants/colors";

const float = keyframes`
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
`;

const fadeInOut = keyframes`
  0%, 100% { opacity: 0.3; }
  50% { opacity: 0.7; }
`;

const EmptyCalendarContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const Calendar = styled.div`
  width: 85%;
  height: 85%;
  max-width: 170px;
  max-height: 170px;
  background: white;
  border-radius: 12px;
  border: 3px solid ${colors.PURPLE};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: ${float} 3s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const CalendarHeader = styled.div`
  height: 25%;
  background: ${colors.GRADIENT_PURPLE};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: -8px;
    width: 6px;
    height: 16px;
    background: ${colors.PURPLE};
    border-radius: 3px;
  }

  &::before {
    left: 20%;
  }

  &::after {
    left: 40%;
  }
`;

const CalendarBody = styled.div`
  flex: 1;
  padding: 8%;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4%;
`;

const CalendarDay = styled.div<{ $delay: number }>`
  aspect-ratio: 1;
  border-radius: 4px;
  background: ${colors.PURPLE_LIGHTER};
  animation: ${fadeInOut} 2s ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay}s;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 0.5;
  }
`;

const EmptyCalendar: React.FC = () => {
  return (
    <EmptyCalendarContainer>
      <Calendar>
        <CalendarHeader />
        <CalendarBody>
          {Array.from({ length: 21 }).map((_, index) => (
            <CalendarDay key={index} $delay={index * 0.1} />
          ))}
        </CalendarBody>
      </Calendar>
    </EmptyCalendarContainer>
  );
};

export default EmptyCalendar;
